import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { HistoryService } from 'src/app/service/management/history.service';

@Component({
    selector: 'app-history-logs-dialog',
    templateUrl: './history-logs-dialog.component.html',
    styleUrls: ['./history-logs-dialog.component.scss'],
    standalone: false
})
export class HistoryLogsDialogComponent implements OnInit {
  gridApi: any;
  icons;
  frameworkComponents;
  context: any;

  eventType: string;
  queueId: number;
  columnDefs = [];
  rowData = [];
  errormsg
  defaultColDef
  constructor(public dialogRef: MatDialogRef<HistoryLogsDialogComponent>, @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly constants: Constants,
    private readonly historyService: HistoryService, private readonly ngxUiLoaderService : NgxUiLoaderService) {
    this.context = {
      componentParent: this
    };
    this.frameworkComponents = {};
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
  }
  ngOnInit(): void {
    this.eventType = this.dataStore.eventType
    this.queueId = this.dataStore.queueId;
    this.defaultColDef = {
      suppressMovable: true, wrapText: true, suppressHeaderFilterButton: true ,suppressCellSelection: true
    }
    this.columnDefs = [
      {
        headerName: "Timestamp", field: "timestamp",
        sortable: true, unSortIcon: true, autoHeight: true, width: 50
      },
      {
        headerName: "Period", field: "period",
        autoHeight: true, sortable: true, unSortIcon: true, width: 40
      },

      {
        headerName: "Message", field: "message", cellClass: "left_align", sortable: true, unSortIcon: true,
        autoHeight: true,
      }
    ];
    this.getHistoryLogs(this.queueId)
  }


  getHistoryLogs(queueId) {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)

    this.historyService.loadDataHistoryLogsDialog(queueId).subscribe(
      response => {
        this.rowData = response
        this.gridApi?.setGridOption('rowData', this.rowData);
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }, error => {
        console.info(error)
        this.errormsg = this.constants.APIErrorMessage
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }
    );
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  close(): void {
    this.dialogRef.close(
      { event: "CloseEvent" }
    );
  }
}
